var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['auto-size', { 'allow-overflow': _vm.allowOverflow }]},[_c('transition',{attrs:{"name":_vm.transitionName,"duration":_vm.transitionDuration},on:{"beforeEnter":_vm.beforeEnter,"enter":_vm.enter,"afterEnter":_vm.afterEnter,"leave":_vm.leave}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }